export default __webpack_public_path__ + "static/media/ativo-19-2x.c838239d.png";